(function () {
  class ReportCards extends HTMLElement {
    constructor() {
      super();
      this.swiperContainer = this.querySelector('.swiper-wrapper');
      this.fetchReports(this.dataset.reporttype || '');
      this.title = this.dataset.title || '';
    }
    async fetchReports(reportType) {
      window.allRequests = window.allRequests ? [...window.allRequests] : [];
      window.allRequests.push('request');
      if (reportType === 'pdf-reports') reportType = 'report-files';
      const response = await fetch(
        `${window.apiurl}/public/api/${reportType}?report_date=&email_address=&page=1&size=20${
          window && window.overrideParams
            ? '&' + window.overrideParams
            : '&client_id=' + window.customerId
        }`
      );
      if (response.ok) {
        window.completedRequests = window.completedRequests ? [...window.completedRequests] : [];
        window.completedRequests.push('report card');
      } else {
        //hide the section
        this.closest('.report-card').style.display = 'none';
        return;
      }
      const data = await response.json();
      if (data.data === null) {
        await this.createSwiperSlides(data, reportType);
      } else {
        await this.createSwiperSlides(data.data.items, reportType);
      }
    }
    formatDateUK(dateString) {
      const dateObj = new Date(dateString);
      const day = dateObj.getUTCDate().toString().padStart(2, '0');
      const month = (dateObj.getUTCMonth() + 1).toString().padStart(2, '0');
      const year = dateObj.getUTCFullYear();
      return `${day}/${month}/${year}`;
    }
    getDateBarBackgroundColor(reportType) {
      switch (reportType) {
        case 'summaryreports':
          return '#EFF8FF';
        case 'bloodreports':
          return '#FCDFDF';
        case 'microbiomereports':
          return '#E1F9ED';
        default:
          return '#F2E3CA';
      }
    }
    getIcon(reportType) {
      switch (reportType) {
        case 'summaryreports':
          return 'https://cdn.shopify.com/s/files/1/0736/4575/2595/files/Summary_Reports.png?v=1685020386F';
        case 'bloodreports':
          return 'https://cdn.shopify.com/s/files/1/0736/4575/2595/files/Blood_report.png?v=1685020386';
        case 'microbiomereports':
          return 'https://cdn.shopify.com/s/files/1/0736/4575/2595/files/Microbiome_Report.png?v=1685020394';
        case 'dnareports':
          return 'https://cdn.shopify.com/s/files/1/0736/4575/2595/files/DNA_report.png?v=1685020386';
        default:
          return 'https://cdn.shopify.com/s/files/1/0736/4575/2595/files/Summary_Reports.png?v=1685020386';
      }
    }
    getReportDate(report) {
      return report.creation_date || report.create_report_date || report.report_date || null;
    }
    // eslint-disable-next-line sonarjs/cognitive-complexity
    async createSwiperSlides(reports, reportType) {
      let url = '';
      switch (reportType) {
        case 'summaryreports':
          url = 'summary-report';
          break;
        case 'bloodreports':
          url = 'blood-chemistry-report';
          break;
        case 'microbiomereports':
          url = 'microbiome-report/';
          break;
        case 'dna-reports':
          url = 'genetic-report/';
          break;
      }
      let bloodMarkers = [];
      if (reportType === 'bloodreports') {
        bloodMarkers = await this.fetchBloodMarkers();
      }
      reports.sort((a, b) => {
        const dateA = new Date(this.getReportDate(a));
        const dateB = new Date(this.getReportDate(b));
        return dateB.getTime() - dateA.getTime();
      });
      let i = reports.length - 1;
      if (reports.length < 1) {
        this.swiperContainer.innerHTML = '';
        this.closest('.report-card').style.display = 'none';
      }
      reports.forEach((report) => {
        const reportDate = this.getReportDate(report);
        const backgroundColor = this.getDateBarBackgroundColor(reportType);
        let swiperSlideHtml = '';
        if (report.type === '') report.type = 'PDF Report';
        if (reportType === 'report-files') {
          swiperSlideHtml = `
        <div class="swiper-slide report-card">
          <div class="title-bar" data-file-download-button="${report.file_name}"   target='_blank'>
            <div class="img" style="background-image: url('${this.getIcon(reportType)}');"></div>
            <h3 style="margin-bottom: 0;">${report.type}</h3>
            <div class="date-bar" style="background-color: ${backgroundColor};">
            <p style="margin-top: 0; margin-bottom: 0;">Date: ${this.formatDateUK(reportDate)}</p>
            </div>
          </div>
        </div>`;
        } else {
          swiperSlideHtml = `
        <div class="swiper-slide report-card">
          <a class="title-bar" href="/pages/${url}?report=${i}?report_id=${report.id}${
            window && window.overrideParams ? '&' + window.overrideParams : ''
          }" target="_blank" data-reportId="${report.id}">
            <div class="img" style="background-image: url('${this.getIcon(reportType)}');"></div>
            <h3 style="margin-bottom: 0;">${this.title}</h3>
            ${
              reportType === 'bloodreports'
                ? this.renderBloodReportCategories(bloodMarkers, report)
                : ''
            }
            <div class="date-bar" style="background-color: ${backgroundColor};">
            <p style="margin-top: 0; margin-bottom: 0; ">Date: ${this.formatDateUK(reportDate)}</p>
            </div>
          </a>
        </div>
      `;
        }
        this.swiperContainer.insertAdjacentHTML('beforeend', swiperSlideHtml);
        i -= 1;
      });
      this.initializeSwiper();
      const pdfDownloadButtons = this.querySelectorAll('[data-file-download-button]');
      pdfDownloadButtons.forEach((button) => {
        button.addEventListener('click', () => {
          this.fetchPDFReport(button.dataset.fileDownloadButton || '');
        });
      });
    }
    async fetchBloodMarkers() {
      const response = await fetch(`${window.apiurl}/public/api/blood-info?page=1&size=100`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.ok) {
        const data = await response.json();
        if (data?.data?.items?.length > 0) {
          return data.data.items.reduce((acc, marker) => {
            const category = marker.category || 'Other';
            if (!acc[category]) {
              acc[category] = [];
            }
            acc[category].push(marker);
            return acc;
          }, {});
        }
      }
      return [];
    }
    renderBloodReportCategories(bloodMarkers, bloodReport) {
      const completedCategories = Object.entries(bloodMarkers)
        .map(([category, markers]) => {
          return Array.from(
            new Set(
              markers?.map((marker) => (!bloodReport[marker.blood_marker_name] ? '' : category))
            )
          );
        })
        .flat()
        .filter((x) => x !== '');
      if (!completedCategories || completedCategories.length < 1) return '';
      return `<span class="title-category">Categories:</span>
    <div style="">
      ${completedCategories
        .map((category) => {
          return `<div class="badge badge--sm">${category}</div>`;
        })
        .join('')}
    </div>`;
    }
    initializeSwiper() {
      new Swiper(this, {
        slidesPerView: 1.5,
        spaceBetween: 15,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          640: {
            slidesPerView: 1.5,
            centeredSlides: true,
          },
          768: {
            slidesPerView: 4,
          },
          1024: {
            slidesPerView: 4,
          },
        },
      });
    }
    async fetchPDFReport(fileName) {
      if (!fileName) return;
      const response = await fetch(
        `${window.apiurl}/public/api/report-files/get?file_name=${encodeURIComponent(fileName)}`
      );
      const contentType = response.headers.get('content-type') || '';
      if (contentType.includes('application/json')) {
        // S3 file: open presigned URL directly in new tab
        const { url } = await response.json();
        window.open(url, '_blank');
      } else {
        // Legacy local file: download blob and open as object URL
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        window.open(objectUrl, '_blank');
        setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
      }
    }
  }
  customElements.define('report-cards', ReportCards);
})();
